import { __rest } from '../../../../../../_virtual/_tslib.js';
import React, { useContext, useEffect } from 'react';
import { StyledNavbarAdditionalItems } from './Navbar.styles.js';
import { NavbarContext } from './NavbarContext.js';

var NavbarAdditionalItems = function NavbarAdditionalItems(_a) {
  var children = _a.children,
      _a$dataLwtId = _a.dataLwtId,
      dataLwtId = _a$dataLwtId === void 0 ? 'navbar-additional-items' : _a$dataLwtId,
      rest = __rest(_a, ["children", "dataLwtId"]);

  var _useContext = useContext(NavbarContext),
      isDark = _useContext.isDark,
      navItems = _useContext.navItems,
      hasBody = _useContext.hasBody,
      setHasAdditionalNavItems = _useContext.setHasAdditionalNavItems;

  useEffect(function () {
    setHasAdditionalNavItems(true);
  }, []);
  return React.createElement(StyledNavbarAdditionalItems, Object.assign({
    isDark: isDark,
    className: 'helix-unified-nav__additional-items',
    "data-lwt-id": dataLwtId,
    hasNavItems: navItems.length > 0 || hasBody
  }, rest), React.createElement(React.Fragment, null, children));
};

NavbarAdditionalItems.displayName = 'NavbarAdditionalItems';
export { NavbarAdditionalItems as default };